//@flow
import React from 'react';
import {
  compose,
  setDisplayName,
} from 'recompose';
import CascadingFormattedMessage from '@ux/cascading-formatted-message';
import { Content } from '@ux/typeface';
import { withStyles } from '@ux/style-utils';
import stylesheet from './Taken.stylesheet.js';

export const PureExactMatchVoid = ({
  theme,
  fqdn,
  styles,
}) => (
  <Content
    component={'div'}
    theme={theme}
    style={styles.root}
  >
    <div style={styles.info}>
      <div style={styles.text}>
        <CascadingFormattedMessage
          cascade={[
            {
              id: 'dst.exactMatch.v2.void.text',
            },
            {
              id: 'dst.exactMatch.v2.notFound.text',
            },
          ]}
          values={{
            domain: (
              <strong style={styles.fqdn}>{fqdn}</strong>
            ),
          }}
        />
      </div>
    </div>
  </Content>
);

export const enhance = compose(
  setDisplayName('ExactMatchVoid'),
  withStyles(stylesheet),
);

export default enhance(PureExactMatchVoid);
